<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'General'|pgettext('Rental') }}
      </strong>
      <ItpButton
        :text="'Edit...'|gettext"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup>
      <ItpLabeledListGroupItem
        :label="'Name'|pgettext('Rental')"
        :content="rental.name"
        v-if="rental.name"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Description'|pgettext('Rental')"
        :content="rental.description"
        v-if="rental.description"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Status'|pgettext('Rental')"
        :labelCols="labelCols"
      >
        <UcResourceStatusCard
          :resource="rental"
          @reload="evh_7349226261686150_reload($event, {})"
        >
        </UcResourceStatusCard>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Owner company'|pgettext('Rental')"
      >
        <ItpLink
          :text="rental.company.name"
          :to="{
    name: 'app.company',
    params: { id: rental.company_id }
  }"
        >
        </ItpLink>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Site'|pgettext('Rental')"
        v-if="rental.site_id"
      >
        <ItpLink
          :to="{
    name: 'app.property',
    params: { id: rental.site_id }
  }"
        >
          {{ rental.site.name }}
<span :if="rental.site.description">- {{ rental.site.description }}</span>

        </ItpLink>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Categories'|pgettext('Rental')"
        v-if="rental.categories && rental.categories.length"
      >
        <ItpBadge
          :key="value"
          :text="value"
          v-for="value in rental.categories"
        >
        </ItpBadge>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Location'|pgettext('Rental')"
        :content="rental.location_code"
        v-if="rental.location_code"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Lot number'|pgettext('Rental')"
        :content="rental.lot_number"
        v-if="rental.lot_number"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Building number'|pgettext('Rental')"
        :content="rental.house_number"
        v-if="rental.house_number"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Area'|pgettext('Rental')"
        v-if="rental.area"
      >
        <ItpText>
          {{ rental.area }} {{ rental.unit_of_area }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Net floor area'|pgettext('Rental')"
        v-if="rental.net_floor_area"
      >
        <ItpText>
          {{ rental.net_floor_area }} {{ rental.unit_of_area }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Net floor area factor'|pgettext('Rental')"
        v-if="rental.net_floor_area_factor"
      >
        <ItpText>
          {{ rental.net_floor_area_factor }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Validity'|pgettext('Rental')"
      >
        <UcRentalValidityCard
          :item="rental"
        >
        </UcRentalValidityCard>
      </ItpLabeledListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRentalGeneralPanel extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  rental!: object;

  @Watch('rental')
  onRental(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rental")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_emit_9660_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_9660, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8320016629450276_close_9659_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9659, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_9658_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9658, alias=undefined
    return {
      name: "MRentalGeneralDataEditor",
      props: {
        rental: _.cloneDeep(this.rental),
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_7349226261686150_emit_9662_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7349226261686150_emit_9662, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7349226261686150_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7349226261686150_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9656: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9655: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_emit_9660: actions.EmitAction;
    evh_8320016629450276_close_9659: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9658: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9657: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_7349226261686150_emit_9662: actions.EmitAction;
    evh_7349226261686150_reload_9661: actions.EventHandlerImpl;
    evh_7349226261686150_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9656 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9655 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9656,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9655],
      }
    );
    const act_8320016629450276_emit_9660 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_9660_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_9659 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_9660,
        event: "close",
        when: this.evh_8320016629450276_close_9659_getWhen,
        displayName: "emit",
      }
    );
    const act_8320016629450276_showModal_9658 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9658_getActionArgs,
        events: [evh_8320016629450276_close_9659],
      }
    );
    const evh_8320016629450276_clickPreventStop_9657 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9658,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9657],
      }
    );
    const act_7349226261686150_emit_9662 = new actions.EmitAction(
      {
        actionArgs: this.act_7349226261686150_emit_9662_getActionArgs,
        events: [],
      }
    );
    const evh_7349226261686150_reload_9661 = new actions.EventHandlerImpl(
      {
        action: act_7349226261686150_emit_9662,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_7349226261686150_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7349226261686150_reload_9661],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9656,
      evh_7315092382398562_reload_9655,
      evh_7315092382398562_reload,
      act_8320016629450276_emit_9660,
      evh_8320016629450276_close_9659,
      act_8320016629450276_showModal_9658,
      evh_8320016629450276_clickPreventStop_9657,
      evh_8320016629450276_clickPreventStop,
      act_7349226261686150_emit_9662,
      evh_7349226261686150_reload_9661,
      evh_7349226261686150_reload,
    }
  }
}

Vue.component("UcRentalGeneralPanel", UcRentalGeneralPanel);

</script>